<p-fieldset legend="Line Items"> 
    <p class="my-4">
        <p-iftalabel>
            <input pInputText [formControl]="searchQuery" autocomplete="off" fluid/> 
            <label>Search...</label>
        </p-iftalabel>   
        <small id="searchQuery-help">Use Course Code to search (min. 3 characters)</small>
    </p>
    <p class="m-0">
                    <p-table selectionMode="single" 
                    [value]="lineItems" 
                    size="small" 
                    [loading]="loading()" 
                    stripedRows 
                    showGridlines 
                    [paginator]="true"  
                    [rows]="10" [tableStyle]="{ 'min-width': '50rem' }" 
                    [rowsPerPageOptions]="[5, 10,50,100,200,500]" 
                    [(selection)]="selectedLineItem" 
                    dataKey="id"
                    [lazy]="true" 
                    [totalRecords]="totalRecords()" 
                    (onLazyLoad)="onLazyLoad($event)"
                    [first]="first">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="code" style="width:14.2%">
                                    Code <p-sortIcon field="code"/>
                                </th>
                                <th>Tool Name</th>
                                <th pSortableColumn="updatedAt">Updated At <p-sortIcon field="updatedAt"/></th>
                                <th>Gradebook</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-lineItem>
                            <tr [pSelectableRow]="lineItem">
                                <td>{{ lineItem.code }}</td>
                                <td>{{ lineItem.name }}</td>
                                <td>{{ lineItem.updatedAt | date }}</td>
                                <td><i class=""></i>
                                <p-button
                                    type="button"
                                    icon="pi pi-book"
                                    (click)="goToGradeBook(lineItem.id,lineItem.code)"
                                    severity="info"
                                />
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
</p-fieldset>

        